const defaultBoxes = [];
const boxes = (state = defaultBoxes, action) => {
  switch (action.type) {
    case 'EPIK_BOXES_CLEAR':
      return defaultBoxes;
    case 'EPIK_BOXES_SUCCESS':
      return action.boxes;
    default:
      return state;
  }
};

export default boxes;
